var omc_s0 = document.createElement("script");
omc_s0.type = "text/javascript";
omc_s0.src = "https://cdn.jsdelivr.net/npm/js-md5@0.7.3/build/md5.min.js";
document.head.appendChild(omc_s0);

var omc_s1 = document.createElement("script");
omc_s1.type = "text/javascript";
omc_s1.src = "https://chat.omnicommerce.app/webrocket.js";
omc_s1.onload = () => {
	omc.init({
	publicKey: 'ba387b77e0',
	webchat: {
		publicKey: '4e40f55886',
	}, 
	callback : () => {  } // function: Will run after webrocket/webchat has loaded
	})
}
document.head.appendChild(omc_s1);